// @ts-nocheck
import useIsTheme from "@toolkit/Framework/Common/Hooks/useIsTheme";
import * as React from "react";

const UserWayInjector = () => {
    const shouldInjectScript = useIsTheme("common");

    React.useEffect(() => {
        if (shouldInjectScript) {
            const script = document.createElement("script");
            script.setAttribute("data-account", "Y8cAwIst3W");
            script.setAttribute("src", "https://cdn.userway.org/widget.js");
            const body = document.body || document.head;
            body.appendChild(script);

            const noscript = document.createElement("noscript");
            noscript.innerHTML =
                'Please ensure Javascript is enabled for purposes of <a href="https://userway.org">website accessibility</a>';
            body.appendChild(noscript);

            return () => {
                body.removeChild(script);
                body.removeChild(noscript);
            };
        }
    }, [shouldInjectScript]);

    return null;
};

export default UserWayInjector;
